import React from 'react';
import {Route, Router, Redirect, Switch} from 'react-router-dom';
import history from '../../history';
import 'font-awesome/css/font-awesome.css';
import connect from 'react-redux/es/connect/connect';
import Main from "../../containers/Main";
import Privacy from "../../containers/Privacy";
import Contact from "../../containers/Contact";
import Terms from "../../containers/Terms";
import EULA from "../../containers/EULA";
import ChildSafety from "../../containers/ChildSafety";
import Header from "../Header";
import 'App.css'
import Footer from "components/Footer/Footer";
import {Helmet} from "react-helmet";
import {appStoreLink, getParameterByName, setCookie, setUtmParams} from "../../js/helpers/functions";
import Unsubscribe from "../../containers/Unsubscribe";
import DeleteAccount from "../../containers/DeleteAccount";
import OpenApp from "../../containers/OpenApp";
import Invite from '../../containers/Invite';

class App extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			dialogOpen: false,
			block: false,
		};
	}

	componentDidMount() {
		let fbclid = getParameterByName('fbclid', window.location.href);
		if (fbclid) {
			setCookie('utm_source', 'instagram', 3);
		}
		setUtmParams();
	}

	render() {

		return (<div className={'App'}>
				<Helmet>
					<title>Barkr - Unleash The Perfect Pawdates</title>
				</Helmet>
				<Header/>
				<Router history={history}>
					<Switch>
						<Route exact path="/" component={Main}/>
						<Route exact path="/privacy" component={Privacy}/>
						<Route exact path="/terms" component={Terms}/>
						<Route exact path="/eula" component={EULA}/>
						<Route exact path="/child-safety" component={ChildSafety}/>
						<Route exact path="/unsubscribe" component={Unsubscribe}/>
						<Route exact path="/delete_account" component={DeleteAccount}/>
						<Route exact path="/contact" component={Contact}/>
						<Route exact path="/open/:destination" component={OpenApp}/>
						<Route exact path="/invite/:code" component={Invite}/>
						<Route path="/.well-known/apple-app-site-association" onEnter={() => window.location.reload()}/>
						<Route exact path='/instagram' render={() => <Redirect to="/?utm_source=instagram&utm_campaign=december&utm_medium=social"/>}/>
						<Route exact path="/download" render={(router) => {
							setCookie('utm_source', 'instagram');
							setCookie('utm_medium', 'ad_link');
							setUtmParams();
							appStoreLink();
							return <Redirect to="/"/>

						}}/>
						<Route exact path="/woof" render={(router) => {
							setCookie('utm_source', 'instagram');
							setCookie('utm_medium', 'bio_link');
							return <Redirect to="/"/>

						}}/>
						<Route exact path="/bark" render={(router) => {
							appStoreLink();

						}}/>
						<Route render={() => <Redirect to="/"/>}/>
					</Switch>
				</Router>
				<Footer/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		translations: state.i18n
	};
};
export default connect(
	mapStateToProps,
	{}
)(App);
